var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { compileUrl, Refresh$, handleAction, handleActionResponse } from '../services/actions';
import { Container } from '../services/di';
import { filter } from 'rxjs/operators';
import { renderDynamicComponent } from '../render';
import List from '@material-ui/core/List';
import { ListItem, ListItemText } from '@material-ui/core';
var DynamicItemList = /** @class */ (function (_super) {
    __extends(DynamicItemList, _super);
    function DynamicItemList(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.state = {
            items: [],
            loading: true
        };
        return _this;
    }
    DynamicItemList.prototype.componentDidMount = function () {
        var _this = this;
        this.props.dataState.pathChange
            .pipe(filter(function (change) { return change.path.startsWith(_this.props.control.path) && change.sender != _this; }))
            .subscribe(function () { return _this.refreshItems(); });
        if (this.props.control.endpoint) {
            Refresh$
                .subscribe(function () { return _this.refreshItems(); });
        }
        this.refreshItems();
    };
    DynamicItemList.prototype.refreshItems = function () {
        var _this = this;
        if (this.props.control.endpoint) {
            Container.http.get(compileUrl(this.props.control.endpoint, this.props.dataState))
                .then(function (items) {
                _this.setState({
                    items: items
                });
            }, function (error) {
                alert('Failed');
            });
        }
        else if (this.props.control.items) {
            this.setState({
                items: this.props.control.items
            });
        }
        else if (this.props.control.path) {
            this.setState({
                items: this.props.dataState.get(this.props.control.path)
            });
        }
    };
    DynamicItemList.prototype.onClick = function (item, dataState) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.control.click) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleAction(this.props.control.click, item, dataState, {
                                context: this.context
                            })];
                    case 1:
                        response = _a.sent();
                        handleActionResponse(response);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DynamicItemList.prototype.render = function () {
        var _this = this;
        return React.createElement(List, { component: "nav" }, this.state.items
            .map(function (item, index) {
            var dataState = Container.createDataStateService();
            dataState.setRecord(item);
            return React.createElement(ListItem, { button: true, key: index, onClick: function () { return _this.onClick(item, dataState); } },
                React.createElement(ListItemText, { primary: React.createElement(React.Fragment, null, _this.props.control.children
                        .map(function (child, index) { return renderDynamicComponent(index, child, dataState); })) }));
        }));
        // return <div>
        // 	{this.state.items && this.state.items
        // 		.map((item, index) => {
        // 			let dataState = Container.createDataStateService();
        // 			dataState.setRecord(item);
        // 			return <div key={index} onClick={() => this.onClick(item)}>
        // 				{this.props.control.children
        // 					.map((child, index) => renderDynamicComponent(index, child, dataState))}
        // 			</div>;
        // 		})}
        // </div>;
    };
    return DynamicItemList;
}(React.Component));
export default DynamicItemList;
//# sourceMappingURL=ItemList.js.map